import {
    ADD_AD_ATTACHMENT,
    CHANGE_AD_FORM_DATA,
    CHANGE_AD_FORM_SETTINGS,
    CHANGE_APPLICATION_POLICY_SETTINGS, CLOSE_AD_MODAL,
    CREATE_ADVANCED_DISBURSEMENT,
    EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_CREATE_ADVANCED_DISBURSEMENT, FAILED_TO_EDIT_ADVANCE_DISBURSEMENT,
    RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    RECEIVE_CREATE_ADVANCED_DISBURSEMENT,
    REMOVE_AD_FORM_ATTACHMENT
} from "../actions";
import _ from 'lodash';

const defaultState = {
    formData: {
        disbursementsType: '',
        amount: 0,
        damageRange: '',
        attachments: [],
        status: '',
        creationDate: '',
        paymentDate: '',
        paymentInstructionId: '',
        canceled: false,
        id: ''
    },
    failedResponseMsg: '',
    successResponseMsg: '',
    adRequest: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CLOSE_AD_MODAL:
            return defaultState;
        case EDIT_ADVANCE_DISBURSEMENT:
            return {
                ...state,
                failedResponseMsg: defaultState.failedResponseMsg
            };
        case FAILED_TO_EDIT_ADVANCE_DISBURSEMENT:
            let msg = 'Failed to update advance disbursement.' ;
            try{
                msg = action.payload.response.body.message
            }
            catch (e){}
            return  {
                ...state,
                failedResponseMsg: msg
            };
        case RECEIVE_ADVANCE_DISBURSEMENT_BY_ID:
            if(!action.payload.body){
                return {
                    ...state,
                }
            }
            return {
                ...state,
                adRequest: action.payload.body,
                formData: {
                    disbursementsType: action.payload.body.expenseTypeId,
                    amount: action.payload.body.amount,
                    damageRange: action.payload.body.damagesId,
                    attachments: action.payload.body.attatchmentDtos,
                    status: action.payload.body.disbursementStatusMachineName,
                    rejectionReason:action.payload.body.rejectionReasonMachineName,
                    rejectionReasonDetails:action.payload.body.rejectionReasonDetails,
                    canceled: action.payload.body.canceled,
                    creationDate: action.payload.body.creationDate,
                    paymentDate: action.payload.body.paymentDate,
                    paymentInstructionId: action.payload.body.paymentInstructionId,
                    id: action.payload.body.id,
                }
            };
        case REMOVE_AD_FORM_ATTACHMENT:
            let newAttachments = [...state.formData.attachments];
            if (action.payload > -1) {
                newAttachments.splice(action.payload, 1);
            }
            return {
                ...state,
                formData: {
                    ...state.formData,
                    attachments: newAttachments
                },
                changedMadeOnFetchedToba: true
            };
        case ADD_AD_ATTACHMENT:
            return {
                ...state,
                formData: {
                    ...state.formData,
                    attachments: [
                        ...state.formData.attachments,
                        action.payload
                    ]
                }
            };
        case CHANGE_APPLICATION_POLICY_SETTINGS:
            return {
                ...state,
                formData: defaultState.formData,
                failedResponseMsg: defaultState.failedResponseMsg
            };
        case CREATE_ADVANCED_DISBURSEMENT:
            return {
                ...state,
                failedResponseMsg: defaultState.failedResponseMsg,
                successResponseMsg: defaultState.successResponseMsg
            };
        case RECEIVE_CREATE_ADVANCED_DISBURSEMENT:
            return {
                ...state,
                formData: defaultState.formData,
                failedResponseMsg: defaultState.failedResponseMsg,
                successResponseMsg: defaultState.successResponseMsg
            };
        case FAILED_TO_CREATE_ADVANCED_DISBURSEMENT:
            let errorMsg;
            try {
                if(_.isString(action.payload.response.body.message)){
                    errorMsg = action.payload.response.body.message;
                }
                else {
                    errorMsg = 'Failed to create application for advance disbursements.';
                }
            }
            catch (e){
                errorMsg = 'Failed to create application for advance disbursements.';
            }
            return {
                ...state,
                failedResponseMsg: errorMsg
            };
        case CHANGE_AD_FORM_DATA:
            if(action.payload.key == "status"){
                state.formData.rejectionReason = null;
                state.formData.rejectionReasonDetails = null;
            }else if(action.payload.key == "rejectionReason"){
                state.formData.rejectionReasonDetails = null;
            }
            return {
                ...state,
                formData: {
                    ...state.formData,
                    [action.payload.key]: action.payload.value
                },
                failedResponseMsg: defaultState.failedResponseMsg
            };
        case CHANGE_AD_FORM_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        default:
            return state;
    }
};